import { createContext, useState, useEffect } from "react";

export const UserContext = createContext();

export const UserContextProvider = ({ children }) => {
    const [user, setUser] = useState(undefined);

    useEffect(() => {
        let tempUser = '';
        if (!user) {
            tempUser = JSON.parse(localStorage.getItem('bunny.User'))
            if (tempUser) {
                setUser(tempUser)
            }
        }
    }, [])

    const setAuthUser = (user) => {
        setUser(user)
        localStorage.setItem('bunny.User', JSON.stringify(user))
    }

    const removeUser = () => {
        setUser(undefined)
        localStorage.removeItem('bunny.User')
    }

    const checkPermission = (permission, aditionalPermissions = null) => {
        const userPermissions = [...user.project_permissions, ...user.global_permissions]
        if (aditionalPermissions) userPermissions.push(...aditionalPermissions)
        const filterPermission = userPermissions.filter((item) => item.abbreviation == permission)
        return filterPermission && filterPermission.length && filterPermission[0].enabled ? true : false
    }

    const addCustomItem = (key, value) => {
        removeCustomItem(key)
        localStorage.setItem(key, JSON.stringify(value))
    }

    const removeCustomItem = (key) => {
        localStorage.removeItem(key)
    }

    const getCustomItem = (key) => {
        return localStorage.getItem(key)
    }

    return (
        <UserContext.Provider value={{ user, setAuthUser, removeUser, checkPermission, addCustomItem, removeCustomItem, getCustomItem }}>
            {children}
        </UserContext.Provider>
    )
}